/**
 * Walidacja i normalizacja parametru `?type=` formularza /zglos/:slug.
 * Każda nieznana wartość jest mapowana na "full" — gwarancja, że tracking
 * i URL-e nigdy nie używają niepoprawnego typu.
 */
export const VALID_UPDATE_TYPES = ["needs", "info", "full"] as const;
export type UpdateType = (typeof VALID_UPDATE_TYPES)[number];

export const isValidUpdateType = (raw: unknown): raw is UpdateType =>
  typeof raw === "string" &&
  (VALID_UPDATE_TYPES as readonly string[]).includes(raw);

export const normalizeUpdateType = (
  raw: string | null | undefined,
): UpdateType => (isValidUpdateType(raw) ? raw : "full");

/**
 * Spójna polska etykieta typu używana w trackingu (zarówno przy „Formularz
 * otwarty" jak i „Formularz wysłany", a także po przekierowaniu z UUID).
 */
export const trackingTypeLabel = (
  type: UpdateType,
  isNew: boolean,
): "nowe" | "potrzeby" | "dane" | "pełny" => {
  if (isNew) return "nowe";
  if (type === "needs") return "potrzeby";
  if (type === "info") return "dane";
  return "pełny";
};
